// extracted by mini-css-extract-plugin
export default {"currentTab":"TabContainer_currentTab__H3vAt","tab":"TabContainer_tab__Qa0eJ","container":"TabContainer_container__HWWK7"};